
import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Lightbulb } from 'lucide-react';
import { LearningInsightsProps } from './types';

const LearningInsights: React.FC<LearningInsightsProps> = ({
  completedNodes,
  inProgressNodes,
  recentlyCompleted,
  allNodes
}) => {
  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          <Lightbulb className="h-5 w-5 text-sky-500" />
          Learning Insights
        </CardTitle>
      </CardHeader>
      <CardContent>
        <div className="grid grid-cols-2 gap-4 text-center">
          <div className="p-3 rounded-lg bg-muted/50">
            <p className="text-lg font-semibold">{completedNodes.length}</p>
            <p className="text-xs text-black">Completed</p>
          </div>
          <div className="p-3 rounded-lg bg-muted/50">
            <p className="text-lg font-semibold">{inProgressNodes.length}</p>
            <p className="text-xs text-black">In Progress</p>
          </div>
        </div>
        
        {recentlyCompleted.length > 0 && (
          <div className="mt-4 pt-4 border-t">
            <p className="text-sm font-medium mb-2">Recently Completed:</p>
            <div className="space-y-1">
              {recentlyCompleted.slice(0, 2).map((progress) => {
                const node = allNodes.find(n => n.id === progress.node_id);
                return node ? (
                  <p key={progress.id} className="text-xs text-black">
                    • {node.title}
                  </p>
                ) : null;
              })}
            </div>
          </div>
        )}
      </CardContent>
    </Card>
  );
};

export default LearningInsights;
